(function(){
  'use strict';
  const $ = (s,c) => (c||document).querySelector(s);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function escapeHtml(s){ return String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]); }
  function escapeAttr(s){ return escapeHtml(s); }

  function initSearchModal(){
    if (document.getElementById('searchModal')) return;
    const html =
      '<div class="search-modal" id="searchModal" aria-hidden="true">' +
        '<div class="search-modal-overlay" data-search-close></div>' +
        '<div class="search-modal-box" role="dialog" aria-modal="true" aria-label="Buscar">' +
          '<form class="search-modal-form" action="' + root + 'search" method="get" role="search">' +
            '<input type="hidden" name="type" value="product">' +
            '<svg class="search-modal-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3-3"/></svg>' +
            '<input type="search" name="q" class="search-modal-input" placeholder="Buscar pecas, marcas, modelos..." autocomplete="off" id="searchModalInput">' +
            '<button type="submit" class="search-modal-submit">Buscar</button>' +
            '<button type="button" class="search-modal-close" data-search-close aria-label="Fechar">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6 18 18M6 18 18 6"/></svg>' +
            '</button>' +
          '</form>' +
          '<div class="search-modal-suggest" id="searchModalSuggest"></div>' +
        '</div>' +
      '</div>';
    document.body.insertAdjacentHTML('beforeend', html);

    const input = $('#searchModalInput');
    let debounceTimer;
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const q = input.value.trim();
      if (q.length < 2){ $('#searchModalSuggest').innerHTML = ''; return; }
      debounceTimer = setTimeout(() => fetchSuggestions(q), 200);
    });

    document.addEventListener('click', e => {
      if (e.target.closest('[data-search-close]')) { toggleSearch(false); }
    });
  }

  function fetchSuggestions(q){
    const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
    fetch(url).then(r => r.json()).then(data => {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      const box = $('#searchModalSuggest');
      if (!box) return;
      if (products.length === 0){
        box.innerHTML = '<div class="search-modal-empty">Nenhum resultado para "' + escapeHtml(q) + '"</div>';
        return;
      }
      box.innerHTML = products.map(p => {
        const img = p.image || (p.featured_image && p.featured_image.url) || '';
        return '<a class="search-modal-result" href="' + escapeAttr(p.url) + '">' +
          '<img src="' + escapeAttr(img) + '" alt="" loading="lazy">' +
          '<div class="r-info">' +
            '<div class="r-brand">' + escapeHtml(p.vendor || '') + '</div>' +
            '<div class="r-name">' + escapeHtml(p.title) + '</div>' +
            '<div class="r-price">' + escapeHtml(p.price || '') + '</div>' +
          '</div>' +
        '</a>';
      }).join('');
    }).catch(() => {});
  }

  function toggleSearch(forceOpen){
    const modal = $('#searchModal');
    if (!modal) return;
    const isOpen = modal.classList.contains('open');
    const open = forceOpen !== undefined ? forceOpen : !isOpen;
    modal.classList.toggle('open', open);
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('search-open', open);
    if (open){
      setTimeout(() => { const i = $('#searchModalInput'); if (i) i.focus(); }, 100);
    }
  }
  window.toggleSearch = toggleSearch;
  window.toggleHeaderSearch = function(){ toggleSearch(true); };

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') toggleSearch(false);
  });

  function bindButtons(){
    document.querySelectorAll('[data-search-toggle], .ic-btn-search, #headerSearchBtn').forEach(btn => {
      if (btn.dataset.searchBound) return;
      btn.dataset.searchBound = '1';
      btn.addEventListener('click', e => { e.preventDefault(); toggleSearch(true); });
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => { initSearchModal(); bindButtons(); });
  } else {
    initSearchModal(); bindButtons();
  }
})();
